import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { WinService } from 'src/app/services/win.service';
import { SessionService } from 'src/app/services/session.service';
import { Router } from '@angular/router';
import { AddressService } from 'src/app/services/api/address.service';
import { CustomerService } from 'src/app/services/api/customer.service';
import { DebounceService } from 'src/app/services/debounce.service';
import { CartService } from 'src/app/services/api/cart.service';
import { ProductService } from 'src/app/services/api/product.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { ConfirmationmodalComponent } from 'src/app/components/modals/confirmationmodal/confirmationmodal.component';
import { GuidelinesComponent } from 'src/app/components/modals/guidelines/guidelines.component';
import { LoginComponent } from 'src/app/components/modals/login/login.component';
// import { Title }     from '@angular/platform-browser';
/* import * as L from 'leaflet'; */
/* import { latLng, MapOptions, tileLayer, Map, Marker, icon, LeafletMouseEvent } from 'leaflet';*/
import { MapService } from 'src/app/services/map.service';
// import { AgmMap } from "@agm/core";
import { environment as env } from 'src/environments/environment';
import { FbpixelService } from 'src/app/services/api/fbpixel.service';
import { SocketioService } from 'src/app/services/socketio.service';
import { WalletService } from 'src/app/services/api/wallet.service';
// import { flatten } from '@angular/compiler';

declare var google: any;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

	private modalRef : BsModalRef;
	/* map: Map; */
	map: any;

	/*shippingInfo*/
	province: any = "";
	city: any = "";
	zip: any = "";
	contact: any = "";

	address: any = {
		"region": "",
		"region_id": 0,
		"region_code": "",
		"country_id": "PH",
		"street": [
			""
		],
		"postcode": "",
		"city": "",
		"firstname": "",
		"lastname": "",
		"customer_id": 0,
		"email": "",
		"telephone": "",
		"same_as_billing": 1,
		"save_in_address_book": 1,
		"company": ""
	}
	lastAddressSelected: any = null;

	getShippingMethods: any = null;
	shippingMethods: any = null;
	paymentMethods: any = null;
	totals: any = null;
	selectedAddress: any = false;
	proceedCheckoutJsonData: any = null;

	paymentView: string = 'list';
	selectedDragonpayProc: any = null;
	selectedDragonpayProcId: any = null;
	selectedPaymentMethod: any = null;

	showAddressForm: boolean = false;

	customPrice: any = null;
	editAddressId: any = null;
	checkoutDone: boolean;
	quoteId: any = null;

	defaultCoords = {
		"lat": 0,
		"lng": 0
	}
	/**
	 * "lat": 14.6091,
	 * "lng": 121.0223
	 */
	showHint: any = false;

	locationiqkey: any;

	agmIcon: any = {
		url: './assets/icons/marker-icon.png',
		scaledSize: {
			width: 32,
			height: 40
		}
	}

	dragonpayProcessors: any = null;

	voucherCode = '';
	voucherDiscountAmount: any = 0;
	itemDiscountTotal: any = 0;
	availabelvoucherCodeLInk: any = null;

	selectedAddressChangeCallback:any = null;

	doCheckout = {
		checkout: true,
		reasons: []
	};

	mustCashIn: boolean = false;

	constructor(
	    public winService: WinService,
	    public lang: LangService,
    	public sessionService: SessionService,
		public router: Router,
		public addressService: AddressService,
	    public debounce: DebounceService,
	    public cartService: CartService,
	    public productService: ProductService,
		public customerService: CustomerService,
		public modalService: BsModalService,
		public ref: ChangeDetectorRef,
		public mapService: MapService,
		public fbpixel: FbpixelService,
		public socketioService: SocketioService,
		public walletService: WalletService
	) {
		this.getShippingMethods = this.debounce.debounce(function(instance, save_in_address_book){
			if(
				instance.address.region.length > 0 &&
				instance.address.street[0].length > 0 &&
				instance.address.city.length > 0 &&
				instance.address.firstname.length > 0 &&
				instance.address.lastname.length > 0 &&
				instance.address.telephone.length > 0
			){
				instance.save_in_address_book = save_in_address_book;

				let jsonData = {
					"address": instance.address,
					"coords": instance.defaultCoords,
				};
				instance.shippingMethods = null;
				instance.customerService.makeRequest('/rest/entrelable/V1/carts/mine/estimate-shipping-methods', jsonData, 'POST').then(resolve => {
					instance.shippingMethods = resolve;
					instance.computeSubtotal(instance.shippingMethods[0]);
					instance.customerService.setLoader(false);
				});
			}
		}, 500);
	}

	ngOnInit() {
		this.totals = null;

		if(!this.sessionService.user.isLogedIn){
			let config: ModalOptions = {
				backdrop: 'static',
				keyboard: false,
				animated: true,
				ignoreBackdropClick: true,
				initialState: {}
			};
			this.modalRef = this.modalService.show(LoginComponent, config);
			this.modalRef.setClass('login-modal modal-dialog-centered');
			this.modalRef.content.onClose = (myData) => {
				this.modalRef.hide();
				if(myData.forceClose){
					this.router.navigate(['/cart']);
				} else {
					setTimeout(f => {
						this.ngOnInit();
					}, 1000);
				}
			};
		} else {
			this.productService.getCustomPrice().then(customPrice => {
				let cp: any = customPrice;
				if(cp){
					this.customPrice = customPrice[0];
				}
			});
			this.getLogedInCustomer();

			this.addressService.getProvince('PH').then(res => {
			});

			this.cartService.makeRequest('/rest/entrelable/V1/hnd-customer/config/hndcustomer/general/available/code/link', '', 'GET')
			.then(link => {
				this.availabelvoucherCodeLInk = link;
			});

			this.cartService.cartItems = null;
			this.cartService.getCartId().then(cartId => {
				this.quoteId = cartId;
				
				this.removePaymentInfo().then(res => {

					this.cartService.getCartItems().then(res => {
						let items: any = res;

						if(items.length <= 0){
							this.cartService.cartItems = [];
							this.router.navigate(['/catalog']);
						} else {
							items.forEach(item => {
								item['calculated_price'] = 0.00;
								item['calculated_total'] = 0.00;
								let cItems = {
									cart: item,
									product: {},
									child: {},
									attachment: {},
								};

								this.cartService.getItemInfo(cItems);

								if(item.sku.match(/custom-t-shirt-/gi)){
									item.sku = 'custom-t-shirt';
								}
								if(item.sku.match(/custom-canvas-tote-bag-/gi)){
									item.sku = 'custom-canvas-tote-bag';
								}

								this.productService.getProductBySku(item.sku).then(childProd => {
									let childProduct: any = childProd;
									cItems.child = childProduct;

									let sku = childProduct.sku;
									sku = sku.replace('-' + childProduct.name, '');
									this.productService.getProductBySku(sku).then(perProd => {
										let product: any = perProd;

										product.custom_attributes.forEach(attr => {
											if(attr.attribute_code == 'extra_sticky_adhesive_note'){
												product.extra_sticky_adhesive_note = attr.value;
											}
										});

										cItems.product = product;

										let custom_options = item.product_option.extension_attributes.custom_options;

										let opts = product.options;

										item['custom_options'] = [];

										custom_options.forEach((option, key) => {
											opts.forEach(opt => {
												if(parseInt(option.option_id) == opt.option_id){
													if(opt.product_sku == 'custom-t-shirt'){ /** for t-shirt */
														
														custom_options[key]['title'] = opt.title;
														if(opt.title == 'Color'){
															custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
															custom_options[key]['option_value'] = custom_options[key]['option_value'].split('-');
															custom_options[key]['option_value'] = custom_options[key]['option_value'][0];
															item['custom_options'].push(custom_options[key]);
														}
														else if(opt.title == 'Print Location'){
															custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
															item['custom_options'].push(custom_options[key]);
														}
														else if(this.cartService.inArray(opt.title, ['Size-XS','Size-S','Size-M','Size-L','Size-XL','Size-XXL','Size-XXXL'])){
															if(custom_options[key]['option_value']){
																custom_options[key]['title']  = opt.title.replace('-', ' Qty ');
																item['custom_options'].push(custom_options[key]);
															}
														}
														else if(this.cartService.inArray(opt.title, ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'])){
															custom_options[key]['title']  = opt.title;
															item['custom_options'].push(custom_options[key]);
														}
													}
													else if(opt.product_sku == 'custom-canvas-tote-bag'){
														custom_options[key]['title'] = opt.title;

														if(opt.title == 'Sizes' || opt.title == 'Print Location'){
															custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
															item['custom_options'].push(custom_options[key]);
														}
														else if(opt.title == 'Front Print Size' || opt.title == 'Back Print Size'){
															item['custom_options'].push(custom_options[key]);
														}
													}
													else {
														if(opt.title == 'custom size'){
															custom_options[key]['title'] = 'size';
															custom_options[key]['option_value'] = custom_options[key]['option_value'] + ' cm';
															item['custom_options'].push(custom_options[key]);
														}
														else if(opt.title == 'adhesive'){
															custom_options[key]['title'] = opt.title;
															item['custom_options'].push(custom_options[key]);
														}
														else if(opt.title == 'cutting type'){
															custom_options[key]['title'] = opt.title;
															opt.values.forEach(optValue => {
																if(custom_options[key].option_value + '' ==  optValue.option_type_id + '' ){
																	custom_options[key]['option_value'] = optValue.title;
																}
															});
															item['custom_options'].push(custom_options[key]);
														}
													}
												}
											});
										});

										let hasSize = false;
										let hasCuttingType = false;
										setTimeout(() => {
											custom_options.forEach(option => {
												if(option.title){
													let title:string = option.title.toLowerCase();
													if(title == 'size' && option.option_value){
														hasSize = true;
													}
		
													if(title == 'cutting type' && option.option_value){
														hasCuttingType = true;
													}
												}
											});
											
											
											let noCuttingTypeSkus = ['custom-t-shirt', 'custom-canvas-tote-bag', 'custom-cards-Custom Shape'];

											let useSickerRollPricing = this.productService.getCustomAttr('use_sicker_roll_pricing', product) + "";

											if(!this.cartService.inArray(item.sku, noCuttingTypeSkus)){
												if(!useSickerRollPricing.length){
													if(!hasSize || !hasCuttingType){
														this.doCheckout.checkout = false;
														if(!hasSize){
															this.doCheckout.reasons.push("One or more items in your cart don't have the size.");
														}
														if(!hasCuttingType){
															this.doCheckout.reasons.push("One or more items in your cart don't have the cutting type.");
														}
														this.doCheckout.reasons.push("Please go back to the cart page.");
													}
												}
											}


										}, 200);


										this.productService.getProductImage(product.id, 150, 150).then(pImage => {
											if(pImage){
												product['images'] = pImage;
											}
										});
									});
								});

								if(!this.cartService.cartItems){
									this.cartService.cartItems = [cItems];
								} else {
									this.cartService.cartItems.push(cItems);
								}
							});

							/** start for fbpixel */
							let totalsCheckerCount:number = 0;
							let totalsChecker:any = setInterval(() => {
								if(totalsCheckerCount > 120){
									clearInterval(totalsChecker);
								}

								if(this.totals){
									this.fbPixel();
									clearInterval(totalsChecker);
								}

								totalsCheckerCount++;
							}, 1000);
							/** end for fbpixel */
						}
					});

					this.walletService.getWallet();
				});
			});

			this.socketCallBack();

			this.selectedAddressChangeCallback = (data) => {
				this.setShippingAddress(data);
			}
		}
	}

	fbPixel(event = 'InitiateCheckout'){
		this.fbpixel.fbq('track', event, {
			'content_category': 'checkout',
			'content_name': 'checkout',
			'currency': this.totals.base_currency_code,
			'value': this.totals.base_grand_total
		});
		let ttqData = {  
			contents: [],
			content_type: 'product',
			value: this.totals.base_grand_total,
			currency: this.totals.base_currency_code.toUpperCase(),  
		}
		this.cartService.cartItems.forEach(item => {
			if(!item.parent_item_id){
				let price = Math.round((item.cart.price + Number.EPSILON) * 100) / 100;

				ttqData.contents.push({
					content_id: item.product.id + '',
					content_name: item.product.sku,
					quantity: item.cart.qty,
					price: price,
				});
			}
		});
		this.fbpixel.ttq(event, JSON.parse(JSON.stringify(ttqData)));
	}

	getOptionValueTitle(opt:any, co:any){
		let title = [];
		opt.values.forEach(optValue => {
			let coOptionValues = co.option_value.split(',');
			coOptionValues.forEach(coOptionValue => {
				if(coOptionValue + '' ==  optValue.option_type_id + '' ){
					title.push(optValue.title);
				}
			});
		});
		return title.join(', ');
	}

	socketCallBack(){
		let checkIsJoined = setInterval(() => {
			if(this.socketioService.isJoined){
				this.socketioService.addCallback('address_save', 'checkout_page', (data:any) => {
					this.getLogedInCustomer();
				});
				
				this.socketioService.addCallback('checkout_success_place_order', 'checkout_page', (data:any) => {
					if(data.socket_id != this.socketioService.socket.id){
						this.cartReset(false);
						this.router.navigate(['/my/order/confirmation/thankyou/' + data.data]);
					}
				});
				this.socketioService.addCallback('checkout_apply_voucher', 'checkout_page', (data:any) => {
					if(data.socket_id != this.socketioService.socket.id){
						if(data.data.is_remove){
							this.showVoucherInput(false);
							this.voucherCode = '';
						}
						else {
							this.showVoucherInput(true);
							this.voucherCode = data.data.voucher_code;
						}
						this.customerService.setLoader(true);
						this.applyVoucherError = '';
						this.applyVoucherSetShippingAndBilling(data.data.is_remove);
					}
				});
				this.socketioService.addCallback('checkout_delete_address', 'checkout_page', (data:any) => {
					this.getLogedInCustomer();
				});
		
		
				this.socketioService.addCallback('another_tab_or_device_went_to_checkout_page', 'checkout_page', data => {
					if(data.socket_id != this.socketioService.socket.id){
						this.cartService.toastService.add('A user from another tab or device visits the checkout page.', 'info', 0);
						this.cartService.toastService.add('Please select the address again', 'info', 0);
						this.removePaymentInfo();
		
						this.getLogedInCustomer();
						this.selectedMethodInputModel = '';
						this.selectedPaymentMethod = null;
		
						this.socketioService.emitToSelf('another_tab_or_device_is_on_checkout_page', '');
					}
				});
				this.socketioService.addCallback('another_tab_or_device_is_on_checkout_page', 'checkout_page', data => {
					if(data.socket_id != this.socketioService.socket.id){
						this.cartService.toastService.add('A user from another tab or device was already doing the checkout. please let that tab or device complete the checkout.', 'info', 0);
						this.cartService.toastService.add('Or close the other device browser tab and reload this page.', 'info', 0);
						this.cartService.toastService.setPageCover(true);
					}
				});
				
				this.socketioService.emitToSelf('another_tab_or_device_went_to_checkout_page', '');

				clearInterval(checkIsJoined);
			}
		}, 100);
	}

	ngOnDestroy(){
		this.socketioService.removeCallback('address_save', 'checkout_page');
		this.socketioService.removeCallback('change_default_address', 'checkout_page');

		this.socketioService.removeCallback('selected_shipping_method_change', 'checkout_page');
		this.socketioService.removeCallback('payment_method_change', 'checkout_page');
		this.socketioService.removeCallback('checkout_success_place_order', 'checkout_page');
		this.socketioService.removeCallback('checkout_apply_voucher', 'checkout_page');
		this.socketioService.removeCallback('checkout_delete_address', 'checkout_page');
		this.cartService.toastService.setPageCover(false);
	}

	theMarker: any;

	/**
	 * get the information of loged in customer
	 */
	getLogedInCustomer(){
		this.customerService.getLogedInCustomer().then(customer => {
			this.address.email = this.customerService.customer.email;
			this.address.firstname = this.customerService.customer.firstname;
			this.address.lastname = this.customerService.customer.lastname;
			this.address.customer_id = this.customerService.customer.id;

			this.customerService.customer.addresses.forEach((val, key) => {
				if(val['default_shipping']){
					this.setShippingAddress(val, true);
				}
			});
			this.customerService.setLoader(false);
		});
	}

	setShippingAndBillingSocket(method){
		this.socketioService.emitToSelf('selected_shipping_method_change', method);
		this.setShippingAndBilling(method);
	}

	/**
	 * object of the selected shipping method
	 */
	selectedShippingMethod: any = null;

	/**
	 * selected method code
	 */
	selectedMethod: any = null;
	selectedMethodInputModel: any = '';

	/**
	 * set the shipping method to be used
	 */
	setShippingAndBilling(method: any = null, setListPaymentMethods:boolean = true){
		return new Promise(sbResolve => {
			this.selectedMethod = method.carrier_code;
			this.selectedShippingMethod = method;
			this.selectedMethodInputModel = method.carrier_code;

			let jsonData = {  "addressInformation": {
					"shipping_address": this.address,
					"billing_address": this.address,
					"shipping_carrier_code": method.carrier_code,
					"shipping_method_code": method.method_code
				},
				"coords": this.defaultCoords,
				"customer_address_id": this.selectedAddressId
			};
			this.cartService.setLoader(true);
			this.cartService.makeRequest('/rest/entrelable/V1/carts/mine/shipping-information', jsonData, 'POST').then(resolve => {
				let r: any = resolve;
				this.cartService.setLoader(false);
				if(setListPaymentMethods){
					r.payment_methods.forEach((val, key) => {
						if(val.code == 'dragonpay'){
							this.getDragonpayProc(r.totals.base_grand_total);
						}
					});
					this.paymentMethods = r.payment_methods;
				}
				this.totals = r.totals;

				this.mustCashIn = parseFloat(this.totals.grand_total) > parseFloat(this.walletService.wallet.wallet);

				this.setCouponCode();

				sbResolve(true);
			});
		});
	}

	/**
	 * get the dragonpay's available processors depending on
	 * total ammount of the order
	 */
	getDragonpayProc(ammount:any = 0){
		let url = '/rest/entrelable/V1/lns-dragonpay/available/processors?ammount=' + ammount;

		this.customerService.setLoader(true);
		this.customerService.makeRequest(url, '', 'GET').then(resolve => {
			let r: any = resolve;
			this.dragonpayProcessors = r;
			this.customerService.setLoader(false);
		});
	};

	get getDragonpayProc1(){
		let lastKey = (this.dragonpayProcessors.length / 2) - 1;
		let procs = [];
		this.dragonpayProcessors.forEach((val, key) => {
			if(key <= lastKey){
				procs.push(val);
			}
		});
		return procs;
	}
	get getDragonpayProc2(){
		let lastKey = (this.dragonpayProcessors.length / 2) - 1;
		let procs = [];
		this.dragonpayProcessors.forEach((val, key) => {
			if(key > lastKey){
				procs.push(val);
			}
		});
		return procs;
	}

	computeSubtotal(method: any = null) {
		this.proceedCheckoutJsonData = null;
		this.selectedShippingMethod = method;
		let jsonData = {  "addressInformation": {
				"shipping_address": this.address,
				"billing_address": this.address,
				"shipping_carrier_code": method.carrier_code,
				"shipping_method_code": method.method_code
			}
		};
		this.cartService.setLoader(true);
		this.cartService.makeRequest('/rest/entrelable/V1/carts/mine/shipping-information', jsonData, 'POST').then(resolve => {
			let r: any = resolve;
			this.totals = r.totals;
			this.setCouponCode();

			this.cartService.setLoader(false);
		});
	}

	/**
	 * set the payment method to be used
	 */
	settingPaymentMethod = false;

	/**
	 * on this part thepayment method was already clicked/selected by the user
	 * this is a used to trigger which total ti display
	 * either subtotal_with_discount or base_grand_total
	 */
	paymentMethodIsClicked = false;

	setPaymentInfoSocket(method: any = null, dpProc:any = null){
		this.socketioService.emitToSelf('payment_method_change', {
			method: method,
			dpProc: dpProc
		})
		this.setPaymentInfo(method, dpProc);
	}
	/**
	 * set the payment method, if the user clicked a method in the option
	 * @param method
	 */
	setPaymentInfo(method: any = null, dpProc:any = null){
		if(!this.settingPaymentMethod){
			this.settingPaymentMethod = true;
			this.cartService.setLoader(true);

			let applyPaymentUrl = '/rest/entrelable/V1/lns-payments/applypaymentmethod/'+this.quoteId+'/'+method.code;

			let dragonpayProc = null;
			if(dpProc){
				dragonpayProc = dpProc.procId
			}

			let jsonData = {
				dragonpay_procid: dragonpayProc
			};

			this.selectedDragonpayProc = dpProc;
			this.selectedDragonpayProcId = dragonpayProc;
			this.selectedPaymentMethod = method;

			this.cartService.makeRequest(applyPaymentUrl, jsonData, 'POST')
			.then(m => {
				this.setShippingAndBilling(this.selectedShippingMethod, false).then(f => {
					this.settingPaymentMethod = false;

					let jsonData = {
						"paymentMethod": {
							"method": method.code
						},
						"billing_address": this.address,
						"coords": this.defaultCoords,
						"shipping_method": this.selectedShippingMethod
					};

					this.proceedCheckoutJsonData = jsonData;
					this.paymentMethodIsClicked = true;
				});
			});
		}
	}

	removePaymentInfo(){
		return new Promise(res => {
			let url = '/rest/entrelable/V1/hnd-order/quote/remove/paymentmethod/'+this.quoteId;
			this.cartService.makeRequest(url, '', 'GET', false).then(quoteId => {
				this.proceedCheckoutJsonData = null;
				this.selectedDragonpayProcId = '';
				this.selectedPaymentMethod = null;
				res(quoteId);
			});
		});
	}

	/**
	 * place and order
	 */
	proceedToCheckout(){
		if(this.proceedCheckoutJsonData && this.doCheckout.checkout){
			
			this.proceedCheckoutJsonData['selected_address'] = this.lastAddressSelected;

			this.customerService.setLoader(true);

			this.fbPixel('Purchase');

			this.customerService.makeRequest('/rest/entrelable/V1/carts/mine/payment-information', this.proceedCheckoutJsonData, 'POST').then(resolve => {
				if(resolve){
					let r: any = resolve;
					this.cartReset(true);

					this.customerService.setLoader(false);
					this.router.navigate(['my/order/'+r+'/confirmation']);

					this.socketioService.emitToSelf('checkout_success_place_order', r);
				}
				
				this.customerService.setLoader(false);
			});
		}

		if(!this.doCheckout.checkout){
			this.doCheckout.reasons.forEach(reason => {
				this.cartService.toastService.add(reason, 'danger');
			});
		}
	}

	cartReset(isToast:boolean = true){
		this.cartService.cartMine = null;
		this.cartService.cartItems = null;
		this.cartService.cart = null;
		this.cartService.storage.removeItem('cart_id');
		if(isToast){
			this.cartService.toastService.add(this.lang.getLang('l4b'), 'success');
		}
	}

	/**
	 * display the customer address form
	 */
	showAddresForm(_add:any = null){
		this.showHint = false;
		let add = {
			"region": "",
			"region_id": "",
			"region_code": "",
			"country_id": "PH",
			"street": [''],
			"postcode": "",
			"city": "",
			"firstname": this.customerService.customer.firstname,
			"lastname": this.customerService.customer.lastname,
			"customer_id": this.customerService.customer.id,
			"email": this.customerService.customer.email,
			"telephone": "",
			"same_as_billing": 1,
			"save_in_address_book": 1
		}
		if(_add){
			add = _add;
			setTimeout(() => {

				if(this.editAddressId) {
					let url = '/rest/entrelable/V1/lns-api/customer/address/latlng/'+this.editAddressId;
					this.customerService.makeRequest(url, null, 'GET').then(address => {
						if(address[0]['lat'] != null && address[0]['lng'] != null) {

							this.mapService.coords.lat = parseFloat(address[0]['lat']);
							this.mapService.coords.lng = parseFloat(address[0]['lng']);
						} else {
							this.mapService.geoCode(_add).subscribe(result => {
								this.mapService.coords.lat = result['results'][0]['geometry']['location']['lat'];
								this.mapService.coords.lng = result['results'][0]['geometry']['location']['lng'];
							});
						}
					});
				} else {
					this.mapService.geoCode(_add).subscribe(result => {
						this.mapService.coords.lat = result['results'][0]['geometry']['location']['lat'];
						this.mapService.coords.lng = result['results'][0]['geometry']['location']['lng'];
					});
				}


			}, 800);

		} else {
			this.province = '';
			this.city = '';
		}

		this.address = add;

		this.showAddressForm = true;
		this.shippingMethods = null;
		this.paymentMethods = null;
		this.proceedCheckoutJsonData = null;
	}

	/**
	 * set shipping address from the address book
	 * save_in_address_book here is zero we dont want to save it again
	 */
	selectedAddressId: null;
	setShippingAddress(address, loader = true){	
		
		if(loader){
			this.customerService.setLoader(true);
		}
		this.removePaymentInfo().then(res => {
			const add = {
				"region": address.region.region,
				"region_id": address.region.region_id,
				"region_code": address.region.region_code,
				"country_id": address.country_id,
				"street": address.street,
				"postcode": address.postcode ? address.postcode : '',
				"city": address.city,
				"firstname": address.firstname,
				"lastname": address.lastname,
				"customer_id": address.customer_id,
				"email": this.customerService.customer.email,
				"telephone": address.telephone,
				"same_as_billing": 1,
				"save_in_address_book": 0
			}

			this.address = add;
			this.selectedAddressId = address.id;
			this.lastAddressSelected = address;

			this.showAddressForm = false;
			this.shippingMethods = null;
			this.paymentMethods = null;
			this.proceedCheckoutJsonData = null;

			this.getAddressLatLng(address.id);

			// this.getShippingMethods(this, 0);
		});
	}

	getAddressLatLng(id) {
		let url = '/rest/entrelable/V1/lns-api/customer/address/latlng/'+id;
		this.customerService.makeRequest(url, null, 'GET').then(address => {
			if(address[0]['lat'] != null && address[0]['lng'] != null) {
				this.defaultCoords.lat = parseFloat(address[0]['lat']);
				this.defaultCoords.lng = parseFloat(address[0]['lng']);
				this.setShippingCoords();
			} else {
				this.setShippingCoords();
				this.defaultCoords.lat = 0;
				this.defaultCoords.lng = 0;
			}
		});
	}

	setShippingCoords(loader = true) {
		this.customerService.setLoader(true);
		setTimeout(() => {
			this.paymentMethods = null;
			this.proceedCheckoutJsonData = null;
			let jsonData = {
				"address": this.address,
				"coords": this.defaultCoords,
			};
			this.customerService.makeRequest('/rest/entrelable/V1/carts/mine/estimate-shipping-methods', jsonData, 'POST').then(resolve => {
				this.shippingMethods = resolve;
				this.computeSubtotal(this.shippingMethods[0]);
				this.customerService.setLoader(false);
			});
		}, 100);

	}

	timeoutHandler: any;
	dragtime = 0;
	public mouseup() {
		if(this.timeoutHandler) {
			if(this.dragtime <= 2) {
				this.setShippingCoords(true);
			}
			clearInterval(this.timeoutHandler);
			this.dragtime = 0;
			this.timeoutHandler=null;
		}
	}

	public mousedown() {
		this.timeoutHandler = setInterval(() => {
			this.dragtime +=1;
		}, 50) ;
	}

	markerDragEnd(lat, lng, $event) {
		this.defaultCoords.lat = $event.coords.lat;
		this.defaultCoords.lng = $event.coords.lng;
		this.setShippingCoords();
	}

	/**
	 * return false is the user type any char other than int
	 */
	isNumberKey(evt: any){
		let charCode = (evt.which) ? evt.which : evt.keyCode;
		if(
			charCode == 8 ||
			charCode == 110 ||
			charCode == 190 ||
			(charCode >= 96 && charCode <= 105) ||
			(charCode >= 48 && charCode <= 57) ||
			(charCode >= 37 && charCode <= 40)
		){
			return true;
		} else {
			return false;
		}
	}

	get totalDiscount() {
		let total = 0;
		if(this.cartService.cartItems){
			this.cartService.cartItems.forEach(val => {
				total += val.cart.discount;
			});
		}
		return total.toFixed(2);
	}

	cancelAddAddress(){
		this.showAddressForm = false;
		this.editAddressId = null;
		this.mapService.coords.lat = null;
		this.mapService.coords.lng = null;

		this.setShippingAddress(this.lastAddressSelected, true);
	}

	/**
	 * save new address
	 */
	saveAddress(){

		var replace = /"/gi;
		var streetStrToReplace = this. address.street[0];

		/* Replace (") with (') to avoid problem with the backend queries */
		 this.address.street[0] = streetStrToReplace.replace(replace, "");


		if(!this.address.firstname.length){
			this.customerService.toastService.add('Please enter your first name.', 'danger');
		}
		else if(!this.address.lastname.length){
			this.customerService.toastService.add('Please enter your lastname name.', 'danger');
		}
		else if(!this.address.street[0].length){
			this.customerService.toastService.add('Please enter your address', 'danger');
		}
		else if(!this.address.city.length){
			this.customerService.toastService.add('Please select city/municipality', 'danger');
		}
		else if(!this.address.region.length){
			this.customerService.toastService.add('Please select region/province', 'danger');
		}
		else if(!this.address.telephone.length){
			this.customerService.toastService.add('Please enter you telephone/mobile number', 'danger');
		}
		else if(!this.address.telephone.match(/^(09)\d{9}$/))  {
			this.customerService.toastService.add('Please follow the 09XXXXXXXXX format', 'danger');
		} else {
			this.address.lat = this.mapService.coords.lat+"";
			this.address.lng = this.mapService.coords.lng+"";
			this.customerService.setLoader(true);
			let url = '/rest/entrelable/V1/lns-api/customer/address/me';
			if(this.editAddressId) {
				url += '/'+this.editAddressId;
			}
			this.customerService.makeRequest(url, this.address, 'POST').then(address => {
				this.getLogedInCustomer();
				this.customerService.toastService.add('Address successfully saved', 'success');
				this.editAddressId = null;
				this.mapService.coords.lat = null;
				this.mapService.coords.lng = null;

				/** emit to socket server */
				this.socketioService.emitToSelf('address_save', this.address);
			});
		}
	}

	showGuidelines(){
		this.modalRef = this.modalService.show(GuidelinesComponent);
		this.modalRef.setClass('modal-dialog-centered modal-lg modal-guidelines');

		this.modalRef.content.onClose = () => {
			this.modalRef.hide();
		};
	}

	/**
	 * check if there is an paymay fee
	 */
	get paymayFee(){
		let result: any = '';
		if(this.totals){
			let segments = this.totals.total_segments;
			segments.forEach(segment => {
				if(segment.code == 'paymaya_fee' || segment.code == 'dragonpay_fee'){
					let total = this.totals.subtotal_with_discount + this.totals.shipping_amount;
					total = this.totals.base_grand_total - total;
					result = ''+total;
				}
			});
		}
		return result;
	}

	isVoucherInputShow: boolean = false;
	applyVoucherError: any = '';

	showVoucherInput(show:boolean = true){
		this.isVoucherInputShow = show;
	}

	applyVoucherSocket(remove:boolean = false){
		let jsonData = {
			is_remove: remove,
			voucher_code: this.voucherCode
		}
		this.socketioService.emitToSelf('checkout_apply_voucher', jsonData);
	}

	applyVoucher(remove:boolean = false){
		if(remove){
			this.voucherCode = '';
		}

		let url = '/rest/entrelable/V1/hnd-order/cart/apply/coupon';
		let jsonData = {
			"coupon_code": this.voucherCode.length > 0 ? this.voucherCode : null
		};
		this.customerService.setLoader(true);
		this.applyVoucherError = '';

		this.customerService.doRequest(url, jsonData, 'POST', false).then(coupon => {
			let c:any = coupon;
			if(!c.error && c.result){
				this.customerService.setLoader(false);
				this.applyVoucherSocket(remove);
				this.applyVoucherSetShippingAndBilling(remove);
			} else {
				this.customerService.setLoader(false);
				this.applyVoucherError = c.error.error.message;
			}
		});
	}

	applyVoucherSetShippingAndBilling(remove:boolean = false){
		this.setShippingAndBilling(this.selectedShippingMethod, false).then(res => {
			if(this.selectedPaymentMethod){
				this.settingPaymentMethod = false;
				this.proceedCheckoutJsonData = {
					"paymentMethod": {
						"method": this.selectedPaymentMethod.code
					},
					"billing_address": this.address,
					"shipping_method": this.selectedShippingMethod,
					"coords": this.defaultCoords,
				};
				this.paymentMethodIsClicked = true;
			}
			if(remove){
				this.isVoucherInputShow = false;
			}
		});
	}

	setCouponCode(){
		this.itemDiscountTotal = 0;
		this.totals.items.forEach(item => {
			this.itemDiscountTotal += item.discount_amount;
		});

		if(typeof this.totals['coupon_code'] != 'undefined'){
			this.voucherCode = this.totals['coupon_code'];
			this.voucherDiscountAmount = this.totals.discount_amount - this.itemDiscountTotal;
			this.isVoucherInputShow = true;
		} else {
			this.voucherCode = '';
			this.voucherDiscountAmount = 0;
		}
	}
}
